import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Login from './components/auth/Login';
import ArchivedPlants from './components/layout/ArchivedPlants';
import Home from './components/layout/Home';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route path="/admin" element={<Login />}></Route>
        <Route path="/gifted" element={<ArchivedPlants />}></Route>
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;
